export interface ToastAction {
  actionMessage: string;
  handler: () => void;
}

export class ToastType {
  public static ERROR: ToastTypeName = 'error';
  public static SUCCESS: ToastTypeName = 'success';
  public static WARNING: ToastTypeName = 'warning';
  public static INFO: ToastTypeName = 'info';
}

export class ToastColors {
  public static ERROR_COLOR = '#e5322c';
  public static SUCCESS_COLOR = '#68bb4b';
  public static WARNING_COLOR = '#fab900';
  public static INFO_COLOR = '#5e92fc';

  public static HEX_COLORS = new Map([
    [ToastType.ERROR, ToastColors.ERROR_COLOR],
    [ToastType.SUCCESS, ToastColors.SUCCESS_COLOR],
    [ToastType.WARNING, ToastColors.WARNING_COLOR],
    [ToastType.INFO, ToastColors.INFO_COLOR],
  ]);

  static hex(type: ToastTypeName): string {
    return this.HEX_COLORS.get(type);
  }
}

export type ToastTypeName = 'error' | 'success' | 'warning' | 'info';

export class ToastIcons {
  private static readonly ICONS = new Map<ToastTypeName, string>([
    [ToastType.ERROR, 'pso:warning_m'],
    [ToastType.WARNING, 'pso:alert_m'],
    [ToastType.SUCCESS, 'pso:success_m'],
    [ToastType.INFO, 'pso:info_m'],
  ]);

  static icon(type: ToastTypeName): string {
    return this.ICONS.get(type);
  }
}

export interface ActiveToast {
  id: number;
  message: string;
  type: ToastTypeName;
  duration: number;
}
